module.exports = __webpack_public_path__ + "static/media/sort_selected.ad55fa68.svg";